import { render, staticRenderFns } from "./EditRetailerModal.vue?vue&type=template&id=63898216"
import script from "./EditRetailerModal.vue?vue&type=script&lang=js"
export * from "./EditRetailerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports